namespace Matrix.Data {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.editor()
    export class StoredProcParametersDialog extends Serenity.TemplatedDialog<any> {

        private editor: StoredProcParametersEditor;

        constructor() {
            super();

            this.editor = new StoredProcParametersEditor(this.byId('ParametersEditor'));
            this.dialogTitle = "Execute Stored Proc";
        }

        okClick: () => void;

        protected getDialogOptions() {
            var opt = super.getDialogOptions();

            opt.buttons = [
                {
                    text: 'OK',
                    click: () => this.okClick && this.okClick()
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];

            return opt;
        }

        public setParameters(items: DataParameter[]) {
            this.editor.setItems(items);
        }

        public getParameterValues() {
            return this.editor.getParameterValues();
        }

        protected getTemplate() {
            return `<div>
<div style="font-size: 14px; padding: 10px;">As the selected stored proc have some parameters without default values, please enter values to pass to the stored proc below:</div>
<div id="~_ParametersEditor"></div>
</div>`
        }
    }
}